export default __webpack_public_path__ + "static/rule-01-thin-clothing-55bb6a2dc92077a0c4eedc8f76da168c.png";